import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { NgbDateStruct, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { UpdateProfileService } from 'app/modules/update-profile/services/update-profile.service';
import { Constants } from 'app/shared/constant/constants';
import { AddOnOrderService } from '../../services/add-on-order.service';
import { ConstantsKey } from 'app/shared/constant/constants-keys';


@Component({
  selector: 'add-on-order-details',
  templateUrl: './add-on-order-details.component.html',
  styleUrls: ['./add-on-order-details.component.scss'],
})
export class AddOnOrderDetailsComponent implements OnInit {


  public orderId;
  public orderType;
  public showLoader: boolean = false;
  public orderDetails: any;
  public eSIMQrCodeImg: any;
  public xplroerDocumentList;
  public paymentDetails;

  constructor(
    private addOnOrderService: AddOnOrderService,
    public router: Router,
    private route: ActivatedRoute,
    public toast: ToastrService,
    public modalService :NgbModal
  ) {

  }

  ngOnInit(): void {

    this.route.params.subscribe((params: Params) => {
      this.orderType = params['orderType'];
      this.orderId = params['orderId'];
        this.getOrderDetails();
    });

  }



  getOrderDetails() {
    if(this.orderType == "esim") {
      this.addOnOrderService.getEsimOrderDetails(this.orderId).subscribe(resp => {
        this.showLoader = false;
        this.orderDetails = resp.body;
        if(this.orderDetails["orderStatus"] == "COMPLETED")  {
          this.addOnOrderService.getESimQrCode(this.orderId).subscribe(qrResp => {
            console.log("---------------------------------------------------------------");
            console.log(qrResp.body);
            this.eSIMQrCodeImg  = qrResp.body;
          });
        }
      },err => {
        this.showLoader = false;
        this.toast.error(err.error.message);
      });
    } else if(this.orderType == "lounge") {
      this.addOnOrderService.getLoungeOrderDetails(this.orderId).subscribe(resp => {
        this.orderDetails = resp.body;
      }, err => {
        this.showLoader = false;
        this.toast.error(err.error.message);
      });
    } else if(this.orderType == "xplorer") {
      this.addOnOrderService.getXplorerCardOrders(this.orderId).subscribe(resp => {
        let xplorerCardObj = resp.body;
        this.orderDetails = xplorerCardObj["order"];
        this.xplroerDocumentList = xplorerCardObj["documents"];
        this.paymentDetails = xplorerCardObj["paymentDetails"];        
      }, err => {
        this.showLoader = false;
        this.toast.error(err.error.message);
      });
      

    }

  }

  downloadLoungPass(url) {
    window.open(url);
  }

  retryPayment() {

    let orderPaymentData = {"orderId": this.orderId, "orderType": this.orderType , "orderData": this.orderDetails}
    sessionStorage.setItem(ConstantsKey.ADD_ON_RETRY_PAY_ORDER, JSON.stringify(orderPaymentData));

    if(this.orderType == "esim") {
      this.router.navigate(['/link-buy-esim']);
    } else if(this.orderType == "lounge") {
      this.router.navigate(['/buy-lounge']);
    } else if(this.orderType == "xplorer") {
      this.router.navigate(['/retry-payment', this.orderId]);
    }

  }

  downloadInvoice() {
    window.open(this.orderDetails?.invoiceUrl);    
  }


}


